/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@pages/AdminPage/config/api.config';
import { notificationUserConfig } from '@pages/AdminPage/config/notifications.config';
import { SUSPEND_USER } from '@pages/AdminPage/api/graphql';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ISuspendUserPluginMethods extends IPluginMethodMap {
  getSuspendUserSync(args?: any): any;
}

export class SuspendUserPlugin implements IAgentPlugin {
  readonly methods: ISuspendUserPluginMethods;

  constructor() {
    this.methods = {
      getSuspendUserSync: this.getSuspendUserSync.bind(this),
    };
  }

  async getSuspendUserSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.suspendUser();
    //   return {
    //   notification: notificationUserConfig?.suspendUserSuccess
    //  };
  }

  //Graphql Query example
  async suspendUser(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    //const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(SUSPEND_USER, {
            vuid: args,
          })
          .toPromise();
        if (res?.data?.suspendUser) {
          return {
            ...res?.data?.suspendUser,
            notification: notificationUserConfig?.suspendUserSuccess,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in activate User', err?.message);
      throw err;
    }
  }
}
